
import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class USBUploadService {

    static USBUploadTE(file, CompanyCode, email){

        var data= {
            file: file,
            COMPANY_CODE: CompanyCode,
            email: email
        }; 
        return axios.post(BaseUrl+ `USBUploadTE`, data);
    }

}


// WEBPACK FOOTER //
// ./src/Services/USBUploadService/usbUploadService.js